import { ListItemIcon, MenuItem } from "@mui/material";
import { MODAL_TYPES } from "../config/MODALES_TYPES.js";
import SummarizeIcon from "@mui/icons-material/Summarize";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import { Mail, Undo } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";

import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CancelIcon from "@mui/icons-material/Cancel";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableChartIcon from "@mui/icons-material/TableChart";
import CloseIcon from "@mui/icons-material/Close";
import { ROW_ACTIONS } from "../config/ROW_ACTIONS.js";
import { TABLE_VARIANTS } from "../config/TABLE_VARIANTS.js";

export const buildRowActions = ({ row, closeMenu, onAction, variant }) => {
  const actions = [];

  const isCompleted = variant === TABLE_VARIANTS.COMPLETO;
  const isPendiente = variant === TABLE_VARIANTS.PENDIENTE;

  const comprobante = row.comprobante?.toUpperCase();

  const isRecibo = comprobante === "RECIBO";
  const isNC = comprobante === "NOTA DE CREDITO";
  const isND = comprobante === "NOTA DE DEBITO";
  const isAjuste = comprobante === "AJUSTE CTACTE";
  const isFactura = !isRecibo && !isNC && !isND && !isAjuste;
  const canCancelInvoice = localStorage.getItem("anula_facturas") === "1"; //Indica si el usuario tiene o no permiso para cancelar facturas con NC.

  if (isAjuste)
    actions.push(<MenuItem disabled={true}>No hay opciones</MenuItem>);

  if (isFactura || isNC || isND) {
    actions.push(
      <MenuItem
        key="ver-factura"
        disabled={isPendiente}
        onClick={() => {
          closeMenu();
          onAction({
            type: MODAL_TYPES.VER_FACTURA,
            row,
          });
        }}
      >
        <ListItemIcon>
          <PictureAsPdfIcon color="secondary" />
        </ListItemIcon>
        Visualizar
      </MenuItem>,
      <MenuItem
        key="Reenviar-por-mail"
        disabled={isPendiente}
        onClick={() => {
          closeMenu();
          onAction({
            type: MODAL_TYPES.ENVIAR_POR_MAIL,
            row,
          });
        }}
      >
        <ListItemIcon>
          <Mail color="primary" />
        </ListItemIcon>
        Reenviar por mail
      </MenuItem>,
    );
  }
  if (isFactura) {
    actions.push(
      <MenuItem
        key="detalle-factura"
        onClick={() => {
          closeMenu();
          onAction({
            type: MODAL_TYPES.DETALLE_FACTURA,
            row,
          });
        }}
      >
        <ListItemIcon>
          <SummarizeIcon color="default" />
        </ListItemIcon>
        Ver saldo
      </MenuItem>,
    );
  }
  if (isFactura && canCancelInvoice) {
    actions.push(
      <MenuItem
        key="anular-factura"
        disabled={String(row.estado).toLowerCase() === "anulado" || isPendiente}
        onClick={() => {
          closeMenu();
          onAction({
            type: ROW_ACTIONS.ANULAR_FACTURA,
            row,
          });
        }}
      >
        <ListItemIcon>
          <DoDisturbOnIcon color="warning" />
        </ListItemIcon>
        Anular
      </MenuItem>,
    );
  }

  if (isRecibo) {
    actions.push(
      <MenuItem
        key="ver-recibo"
        onClick={() => {
          closeMenu();
          onAction({
            type: ROW_ACTIONS.DETALLE_RECIBO,
            row,
          });
        }}
      >
        <ListItemIcon>
          <PictureAsPdfIcon color="primary" />
        </ListItemIcon>
        Ver recibo
      </MenuItem>,

      <MenuItem
        key="aplicar-recibo"
        // disabled={row.saldoImputado === 0}
        disabled={true} // Que por ahora solo se pueda aplicar mediante el boton de la toolbar. Dejar para despues esto.
        onClick={() => {
          closeMenu();
          onAction({ type: ROW_ACTIONS.APLICAR_RECIBO, row });
        }}
      >
        <ListItemIcon>
          <AccountBalanceWalletIcon sx={{ color: "#631700 " }} />
        </ListItemIcon>
        Aplicar recibo
      </MenuItem>,

      <MenuItem
        key="anular-recibo"
        onClick={() => {
          closeMenu();
          onAction({ type: ROW_ACTIONS.ANULAR_RECIBO, row });
        }}
        disabled={row.estado === "Anulado" || isPendiente}
      >
        <ListItemIcon>
          <CancelIcon color="error" />
        </ListItemIcon>
        Anular recibo
      </MenuItem>,

      <MenuItem
        key="desaplicar-recibo"
        disabled={isPendiente}
        onClick={() => {
          closeMenu();
          onAction({ type: ROW_ACTIONS.DESAPLICAR_RECIBO, row });
        }}
      >
        <ListItemIcon>
          <Undo sx={{ color: "#F59E0B" }} />
        </ListItemIcon>
        Deshacer aplicación
      </MenuItem>,
    );
  }

  //Aca tengo que poner el resto de las rowActions una vez que me digan que tengo que poner en envasado

  return actions;
};
